"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarLayoutView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const Wrap = app_1.styled.div `
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: ${(theme) => theme.colors.primary};
  svg {
    color: ${(theme) => theme.colors.primary};
  }
`;
const Header = app_1.styled.header `
  position: sticky;
  display: flex;
  justify-content: space-between;
  align-items: center;
  top: 0;
  width: 100%;
  z-index: 10;
  height: var(--nav-height);
  min-height: 4rem;
  padding: ${(theme) => theme.spacing.small};
  background: ${(theme) => theme.background};
`;
const Container = app_1.styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const TextButton = (0, app_1.styled)(ui_1.Button) `
  color: ${(theme) => theme.colors.primary};
  background: transparent;
  padding: 0;
  min-width: unset;
`;
const CloseText = app_1.styled.span `
  padding-left: ${(theme) => theme.spacing.extraSmall};
  letter-spacing: 0.175rem;
  font-size: 0.875rem;
`;
function SideBarLayoutView({ children, handleBack, handleClose, customHeader: CustomHeader, }) {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Wrap, { children: [(0, jsx_runtime_1.jsxs)(Header, { children: [handleClose && ((0, jsx_runtime_1.jsxs)(TextButton, Object.assign({ "aria-label": "Close", kind: "transparent", onClick: handleClose }, { children: [(0, jsx_runtime_1.jsx)(svg_1.SvgCloseMenu, {}), (0, jsx_runtime_1.jsx)(CloseText, { children: t('label.close') })] }))), handleBack && ((0, jsx_runtime_1.jsx)(TextButton, Object.assign({ "aria-label": "Go back", kind: "transparent", onClick: handleBack }, { children: '<- BACK' }))), CustomHeader && (0, jsx_runtime_1.jsx)(CustomHeader, {})] }), (0, jsx_runtime_1.jsx)(Container, { children: children })] }));
}
exports.SideBarLayoutView = SideBarLayoutView;
